export enum FinanceTransactionType {
  Payment = 1,
  Refund = 2,
  Return = 3,
  Cancellation = 4,
  Void = 5,
}
